import { useAtomBalance } from '@ui/hooks/useAtomBalance';
import { useBalance } from '@ui/hooks/useBalance';
import { useLiquidCoinBalance } from '@ui/hooks/useLiquidCoinBalance';
import useVnoBalance from '@ui/hooks/useVnoBalance';
import useWcroBalance from '@ui/hooks/useWcroBalance';
import { currentWallet, getNetworkConfig } from '@veno-app/wallet';

import { useAccountModalStore } from './useAccountModalStore';

const { useAccount, useIsConnected } = currentWallet;

const useAccountModalData = () => {
  const isOpen = useAccountModalStore((s) => s.isOpen);
  const toggle = useAccountModalStore((s) => s.toggleAccountModal);
  const account = useAccount();
  const isConnected = useIsConnected();
  const { data: balance } = useBalance();
  const { data: atomBalance } = useAtomBalance();
  const { data: lcroBalance } = useLiquidCoinBalance({
    coinMode: 'cro',
    enabled: isOpen,
  });
  const { data: latomBalance } = useLiquidCoinBalance({
    coinMode: 'atom',
    enabled: isOpen,
  });
  const { wcroBalance } = useWcroBalance({ enabled: isOpen });
  const { vnoBalance } = useVnoBalance({ enabled: isOpen });
  const explorerUrl = getNetworkConfig().blockExplorerUrls?.[0];

  return {
    isOpen,
    toggle,
    account,
    isConnected,
    balance,
    lcroBalance,
    atomBalance,
    latomBalance,
    vnoBalance,
    explorerUrl,
    wcroBalance,
  };
};

export default useAccountModalData;
